import React from 'react';
import LoginForm from '../../../components/forms/LoginForm';
import { useAuth } from '../../../providers/auth';
import Loader from '../../../components/Loader';
import { AuthLayout } from '../../../components/layouts/AuthLayout';

export function LoginPage() {
  const { loading } = useAuth();

  if (loading) {
    return <Loader fullScreen label="Entrando" />;
  }

  return (
    <AuthLayout
      title="Acesse sua conta"
      description="Entre com seu usuário e senha para continuar."
    >
      <LoginForm />
    </AuthLayout>
  );
}
